import React from "react";
import { useAppStore } from "@/store/useAppStore";
import { CrowdVotingResults } from "../CrowdVotingResults";
import { EstimateDistribution } from "../EstimateDistribution";
import { EducationalExplanation } from "../EducationalExplanation";

export const CrowdResultsModal = () => {
  const {
    showCrowdResults,
    crowdData,
    lastResult,
    selectedChallenge,
    setSelectedChallenge,
    setShowCrowdResults,
    setCrowdData,
    setLoading,
    setUserAnswer,
    setLastResult,
  } = useAppStore();
  if (!(showCrowdResults && crowdData && lastResult && selectedChallenge)) {
    return null;
  }

  const handleCloseModal = () => {
    setShowCrowdResults(false);
    setSelectedChallenge(null);
    setCrowdData(null);
    setLoading(false);
    setUserAnswer("");
  };
  return (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
      onClick={handleCloseModal}
    >
      <div
        className="bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 max-w-3xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold">👥 Crowd Results</h3>
          <button
            onClick={handleCloseModal}
            className="text-gray-400 hover:text-white"
          >
            ✕
          </button>
        </div>

        <div className="space-y-6">
          <div className="text-center p-4 bg-white/5 rounded-xl">
            <h4 className="text-lg font-bold mb-2">
              📊 {crowdData.participantCount} People Participated
            </h4>
          </div>

          {selectedChallenge.type === "choice" && <CrowdVotingResults />}

          {selectedChallenge.type === "estimate" && <EstimateDistribution />}

          <div className="hidden md:block">
            <h4 className="text-lg font-bold mb-3">
              💭 Top Reasoning from Participants:
            </h4>
            <div className="space-y-2">
              {crowdData.topReasons.map((reason: string, i: number) => (
                <div key={i} className="p-3 bg-white/5 rounded-xl">
                  <p className="text-sm text-gray-300">"{reason}"</p>
                </div>
              ))}
            </div>
          </div>

          <EducationalExplanation explanation={selectedChallenge.explanation} />

          <div className="text-center pt-4">
            <div className="mb-4 p-4 bg-white/5 rounded-xl">
              <h4 className="text-lg font-bold mb-2">🎯 Your Result</h4>
              <p className="text-lg">
                <span
                  className={`font-bold ${
                    lastResult.points > lastResult.challengePoints * 0.7
                      ? "text-green-400"
                      : "text-yellow-400"
                  }`}
                >
                  +{lastResult.points} points!
                </span>
                {lastResult.beatCrowd && (
                  <span className="block text-brand-light font-bold mt-2">
                    🔥 CROWD BEAT! Bonus points earned!
                  </span>
                )}
              </p>
            </div>

            <button
              onClick={() => {
                setShowCrowdResults(false);
                setSelectedChallenge(null);
                setCrowdData(null);
                setLastResult(null);
                setLoading(false);
                setUserAnswer("");
              }}
              className="bg-brand-teal hover:bg-brand-teal text-white px-8 py-3 rounded-xl font-semibold"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
